import {
	CreatePersonRelatedPeopleDto,
	NamesOfPersonWithRelation,
	UpdateRelatedPersonRelationDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const getAvailablePeopleToRelateToPerson = async (params: {
	personId: string;
	relationType: string;
}): Promise<NamesOfPersonWithRelation[]> => {
	return await makeRequest<ApiV1.Response<NamesOfPersonWithRelation[]>>({
		endpoint: `${formatUnicorn(API_PATHS.PERSON_PERSONID_AVAILABLE_RELATED_PEOPLE_GET, {
			personId: params.personId,
		})}?relationType=${params.relationType}`,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};

export const bulkCreateRelatedPeopleForPerson = async (params: {
	personId: string;
	body: CreatePersonRelatedPeopleDto;
}): Promise<void> => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_RELATED_PEOPLE_POST, {
			personId: params.personId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(params.body),
	}).then((response) => response.payload);
};

export const editPersonRelation = async (params: {
	personId: string;
	relationId: string;
	body: UpdateRelatedPersonRelationDto;
}) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_RELATED_PEOPLE_RELATIONID_PATCH, {
			personId: params.personId,
			relationId: params.relationId,
		}),
		method: HTTP_METHOD.PATCH,
		body: JSON.stringify(params.body),
	}).then((response) => response.payload ?? []);
};
